import React from 'react';
import { useEffectOnce } from 'react-use';
import { Route, Router, Switch, Redirect } from 'react-router-dom'; // Switch, Redirect
import { createBrowserHistory } from 'history';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import Main from '../Layouts/Main';
import { localeList } from '../../utils/Helper';
import store from '../../redux/store';
import { getSiteConfig } from '../../redux/modules/siteConfig/action';
import { getSeason } from '../../redux/modules/season/action';
import { getBrand } from '../../redux/modules/brand/action';
import { getDetailDataList } from '../../redux/modules/detailDataList/action';
import config from '../../config';

import c from '../../config';

// Default Style
import '../../assets/scss/theme.scss';

// cookie
const CookieConsent = loadable(() => import('../../components/CookieConsent'));

// SSO
const SSOStatus = loadable(() => import('../../components/SSOStatus'));

// Routes
const HomePage = loadable(() => import('../../pages/HomePage'));
const IndexPage = loadable(() => import('../../pages/IndexPage'));
const StaticPage = loadable(() => import('../../pages/StaticPage'));
const SpeakersPage = loadable(() => import('../../pages/SpeakersPage'));
const ProgrammePage = loadable(() => import('../../pages/ProgrammePage'));
const PhotoGalleryPage = loadable(() => import('../../pages/PhotoGalleryPage'));
const VideoGalleryPage = loadable(() => import('../../pages/VideoGalleryPage'));
const LinksPage = loadable(() => import('../../pages/LinksPage'));
const PressReleasePage = loadable(() => import('../../pages/PressReleasePage'));
const PromotionPage = loadable(() => import('../../pages/PromotionPage'));
const NoMatch = loadable(() => import('../../pages/NoMatch'));
const ComingSoonPage = loadable(() => import('../../pages/ComingSoonPage'));
const YDCArchivePage = loadable(() => import('../../pages/YDCArchivePage'));
const CollectionsPage = loadable(() => import('../../pages/CollectionsPage'));
const CollectionsDetailPage = loadable(() => import('../../pages/CollectionsDetailPage'));
const DesignersDetailPage = loadable(() => import('../../pages/DesignersDetailPage'));
const YDCDetailPage = loadable(() => import('../../pages/YDCDetailPage'));
const DesignersPage = loadable(() => import('../../pages/DesignersPage'));
const FeaturesPage = loadable(() => import('../../pages/FeaturesPage'));
const FeaturesDetailPage = loadable(() => import('../../pages/FeaturesDetailPage'));
const VideoPage = loadable(() => import('../../pages/VideoPage'));
const YDCAbout = loadable(() => import('../../pages/YDCAbout'));
const VideoDetailPage = loadable(() => import('../../pages/VideoDetailPage'));
const SearchPage = loadable(() => import('../../pages/SearchPage'));
const TermsPage = loadable(() => import('../../pages/TermsPage'));
const AboutusPage = loadable(() => import('../../pages/AboutusPage'));
const TestingPage = loadable(() => import('../../pages/TestingPage'));

// Config Top Application, include languages
const TopApp = loadable(() => import('../../widgets/TopApp'));

const history = createBrowserHistory();

const App = ({ ...props }) => {
  const { siteConfig } = props;
  const { data = {} } = siteConfig || {};
  const { availableLanguages, defaultLanguage, enableSSO, under_construction } = data;
  const isUnderConstruction = under_construction === 'true' || under_construction === true;

  useEffectOnce(() => {
    store.dispatch(getSiteConfig());
    store.dispatch(getSeason());
    store.dispatch(getBrand());

    store.dispatch(
      getDetailDataList(config.pageType.designerPage, null, config.pageType.designerPage),
    );
    store.dispatch(getDetailDataList(config.pageType.videoPage, null, config.pageType.videoPage));
    store.dispatch(
      getDetailDataList(config.pageType.collectionsPage, null, config.pageType.collectionsPage),
    );
    // store.dispatch(
    //   getDetailDataList(config.pageType.featuresPage, null, config.pageType.featuresPage),
    // );
  });

  return (
    <>
      <CookieConsent />
      {enableSSO && <SSOStatus />}
      {availableLanguages && (
        <Router history={history} basename={c.routePathTo}>
          <Route
            path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?`}
            component={TopApp}
          />
          <Main
            availableLanguages={localeList(availableLanguages)}
            isUnderConstruction={isUnderConstruction}
          >
            <Switch>
              {isUnderConstruction && <Route component={ComingSoonPage} />}
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})?`}
                component={HomePage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/s/:pageName`}
                component={StaticPage}
              />
              {/* <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/photo/:pageName/:id?`}
                component={PhotoGalleryPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/video/:pageName/:id?`}
                component={VideoGalleryPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/speaker/:pageName/:id?`}
                component={SpeakersPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/programme/:pageName`}
                component={ProgrammePage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/s/:pageName`}
                component={StaticPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/i/:pageName/:curPage?`}
                component={IndexPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/l/:pageName`}
                component={LinksPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/press-release/:pageName`}
                component={PressReleasePage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/promotion/:pageName`}
                component={PromotionPage}
              /> */}
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/collections`}
                component={CollectionsPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/collections/:id`}
                component={CollectionsDetailPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/designers`}
                component={DesignersPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/designers/:id`}
                component={DesignersDetailPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/ydc/detail/:id`}
                component={YDCDetailPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/YDC`}
                component={YDCArchivePage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/ydc/about`}
                component={YDCAbout}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/highlight`}
                component={FeaturesPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(
                  availableLanguages,
                )})/highlight/:id/:seo`}
                component={FeaturesDetailPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/video`}
                component={VideoPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/video/:id/:seo`}
                component={VideoDetailPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/search`}
                component={SearchPage}
              />
              {/* <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/s/aboutus`}
                component={AboutusPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/s/terms`}
                component={TermsPage}
              />
              <Route
                exact
                path={`${c.routePathTo}/:locale(${localeList(availableLanguages)})/s/testing`}
                component={TestingPage}
              /> */}
              <Route
                exact
                path={`${c.routePathTo}/:path`}
                render={(props) => (
                  <Redirect to={`${c.routePathTo}/${defaultLanguage}/${props.match.params.path}`} />
                )}
              />
              <Route component={NoMatch} />
            </Switch>
          </Main>
        </Router>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(App);

export { App as AppComponent }; // <- For component Unit Test
export default connectStore;
